import { IconFileTimes, IconTimesCircle } from '~/components/Icons'

export const APPLICANT_VISIBLE_APPLICATION_STATUSES = Object.freeze([
	'invitation',
	'pending',
	'interview',
	'hired',
	'denied'
])

export const APPLICANT_WITHDRAWABLE_APPLICATION_STATUSES = Object.freeze([
	'pending',
	'requested',
	'accepted',
	'invitation',
	'interview'
])

export function canApplicantWithdrawApplication(
	application,
	jobOffer = application?.job_offer
) {
	return Boolean(
		jobOffer &&
			APPLICANT_WITHDRAWABLE_APPLICATION_STATUSES.includes(
				application?.status
			)
	)
}

export function getCandidateDenialActionCopy(application) {
	if (application?.status === 'invitation') {
		return {
			action: 'application.decline-invitation.action',
			title: 'application.decline-invitation.confirmation.title',
			prefix: 'application.decline-invitation.confirmation.prefix',
			suffix: 'application.decline-invitation.confirmation.suffix',
			confirm: 'application.decline-invitation.confirm',
			icon: IconTimesCircle
		}
	}

	return {
		action: 'application.withdraw.action',
		title: 'application.withdraw.confirmation.title',
		prefix: 'application.withdraw.confirmation.prefix',
		suffix: 'application.withdraw.confirmation.suffix',
		confirm: 'application.withdraw.confirm',
		icon: IconFileTimes
	}
}

export function getApplicationPrimaryColumnLabelKey(isOrg = false) {
	return isOrg ? 'general.applicant' : 'general.job'
}

const APPLICATION_STAGE_LABEL_KEYS = Object.freeze({
	pending: 'general.requested',
	requested: 'general.requested',
	invitation: 'general.invited',
	accepted: 'general.accepted',
	interview: 'general.interview',
	hired: 'general.hired',
	denied: 'general.denied'
})

export function getVisibleApplicationStatus(status, isOrg = false) {
	if (!isOrg && ['pending', 'requested', 'accepted'].includes(status)) {
		return 'pending'
	}

	return status
}

export function getApplicationStageLabelKey(
	status,
	isOrg = false,
	declineSource = null
) {
	if (!isOrg && status === 'denied' && declineSource === 'withdrawn') {
		return 'application.withdrawn'
	}

	if (
		!isOrg &&
		status === 'denied' &&
		declineSource === 'invitation_declined'
	) {
		return 'application.decline-source.invitation-declined'
	}

	const visibleStatus = getVisibleApplicationStatus(status, isOrg)

	return APPLICATION_STAGE_LABEL_KEYS[visibleStatus] || 'general.unknown'
}

export function shiftApplicationStatusCount(counts, from, to) {
	const next = { ...(counts || {}) }
	if (!from || !to || from === to) return next

	if (Object.prototype.hasOwnProperty.call(next, from)) {
		next[from] = Math.max(0, Number(next[from]) - 1)
	}

	next[to] = Number(next[to] || 0) + 1

	return next
}

function stageCountKey(status) {
	return status === 'requested' ? 'pending' : status
}

export function shiftPaginationForVisibleStage(
	pagination,
	activeStatus,
	from,
	to
) {
	const next = { ...(pagination || {}) }
	const source = stageCountKey(from)
	const destination = stageCountKey(to)
	if (!activeStatus || !source || !destination || source === destination) {
		return next
	}

	const leaving = source === activeStatus
	const entering = destination === activeStatus
	if (leaving === entering) return next

	const total = Math.max(0, Number(next.total || 0) + (entering ? 1 : -1))
	const perPage = Number(next.per_page)
	const lastPage =
		perPage > 0 ? Math.max(1, Math.ceil(total / perPage)) : next.last_page

	return { ...next, total, last_page: lastPage }
}

export function applicationsForVisibleStage(
	applications,
	visibleStatus,
	isOrg = false
) {
	return (applications || []).filter(
		application =>
			getVisibleApplicationStatus(application.status, isOrg) ===
			visibleStatus
	)
}
